import { h } from 'preact';
import * as BaseComp from 'components/shared/header/header.js';
import s from 'components/shared/header/header.sss';

function extractQueryParam(url, name) {
	let result = url.match(new RegExp('(?:\\?|&(?:amp;)?)'+name+'=([^&]+)'));
	if(!result) return '';
	return result[1];
}

export default class Header extends BaseComp.default {

	renderSignup() {
		if(!this.props.appData.header.neonratedMailingUrl) return;
		let url = this.props.appData.header.neonratedMailingUrl;
		let u = extractQueryParam(url, 'u');
		let id = extractQueryParam(url, 'id');
		return (
			<form class={s.signup} action={url} method="post" name="mc-embedded-subscribe-form" target="_blank" novalidate>
				<label for="mce-EMAIL">SIGN UP FOR UPDATES</label>
				<input type="email" class={s.email} value="" name="EMAIL" id="mce-EMAIL" placeholder="email address" required />
				<input type="text" class={s.hidden} name={'b_'+u+'_'+id} tabindex="-1" value="" aria-hidden="true" />
				<input type="submit" class={s.button} value="Subscribe" name="subscribe" />
			</form>
		);
	}

	extraContent() {
		let top = super.extraContent();
		if(!this.props.headerData.sideNavActive) {
			let signup = this.renderSignup();
			if(signup) return [].concat(top, signup);
		}
		return top;
	}

	extraDrawerContent() {
		let top = super.extraDrawerContent();
		if(this.props.headerData.sideNavActive) {
			let signup = this.renderSignup();
			if(signup) return [].concat(top, signup);
		}
		return top;
	}

}

export const verticallyCenter = BaseComp.verticallyCenter;
export const dependencies = BaseComp.dependencies;
